import type { MenuRecipesState, Recipe, RecipeUUID } from 'reducers/menu-recipes/recipes'

export const getRecipe =
  (id: RecipeUUID | null) =>
  (state: MenuRecipesState): Recipe | null =>
    id ? state.recipesV3.recipes[id] || null : null
